import axios from '../javascript/custom-axios'
const RESOURCE_NAME = 'categories'

export default { 

  /**
   * @summary Dosya(lar)ı sunucuya yükler
   * @route POST /v1/upload
   * @param {Object} body
   * @param {File[]} body.Files - Yüklenecek dosyalar (array of File)
   * @param {number} body.Type - Dosya tipi (BU: integer)
   * @returns {Promise}
   */
  uploadFile(body) {
    return axios.post(`/v1/upload`, body);
  },

  getFileString(fileId){
    return `${process.env.VUE_APP_API_URL}/v1/files/${fileId}`
  },

  getFile(fileId){
    return axios.get(`${process.env.VUE_APP_API_URL}/v1/files/${fileId}`)
  },
}